module.exports = __webpack_public_path__ + "static/media/code-block.e9f19661.svg";